// extracted by mini-css-extract-plugin
module.exports = {"miniLogoContainer":"MiniLogo_miniLogoContainer__Vejjc","miniLogoImage":"MiniLogo_miniLogoImage__o3ufl"};